// helper for the front to open in other tabs prac, osr ect
import axios from './axios';
import toast from 'react-hot-toast';

const openOsr = async (aff_id) => {
    try {
        let response = await axios.get('/api/osr/relation', { params: { string: aff_id } });
        const raw = response?.data?.data;
        const id = raw?.osrInternalId;
        if (id) {
            const url = `https://distri-raccordement.enedis.fr/?obj=affaires&PTF_ID=22&onglet=carac&AFF_ID=${id}`;
            window.open(url, '_blank');
        } else {
            // toast not found, search directly on osr
            toast.error("Aucune affaire trouvée pour ce numéro OSR. Recherchez sur OSR directement.");
        }
    } catch (error) {
        console.error(error);
    }
};

const openPrac = async (aff_id) => {
    try {
        const url = `https://connect-racco-intranet.enedis.fr/prac-intranet/demande/${aff_id}`;
        window.open(url, '_blank');
    }
    catch (error) {
        console.error(error);
        toast.error("Erreur lors de l'ouverture de la référence PRAC.");
    }
};

const openSge = async (aff_id) => {
    try {
        const url = `https://portail-sge-distributeur-v2.enedis.fr/adc5/?wc=consultation&id=${aff_id}`;
        window.open(url, '_blank');
    } catch (error) {
        console.error(error);
        toast.error("Erreur lors de l'ouverture de la référence SGE.");
    }
};

const openEplans = async (aff_id) => {
    try {
        const url = `https://www.e-plans.fr/Affaire/${aff_id}`;
        window.open(url, '_blank');
    } catch (error) {
        console.error(error);
        toast.error("Erreur lors de l'ouverture de la référence Eplans.");
    }
};

export { openOsr, openPrac, openSge, openEplans };